import { defineComponent as _defineComponent } from 'vue'
import {
  AbSection,
  AbCardListItem,
  AbTitle,
  AbDescription,
  AbContainer,
  AbSectionLayout,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { TextAlign } from '../../../../types';
import { useSectionAnalytics } from '../../../../analytics';
import type { AnalyticLinkItem } from '../../../../analytics/types';
import { computed, ref } from 'vue-demi';

interface FeatureSectionArticlesItem {
  image?: {
    src: string;
    alt?: string | null;
  } | null;
  title: string;
  description?: string | null;
  list?: string[] | null;
  links?:
    | {
        src?: string | null;
        text: string;
        creative_name?: string | null;
      }[]
    | null;
  caption?: string | null;
  contentAlign?: TextAlign | null;
  button?: {
    src: string;
    text?: string | null;
    color?: string | null;
    align?: TextAlign | null;
    creative_name?: string | null;
  } | null;
}

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: FeatureSectionArticlesItem[];
  spacing?: Spacing | null;
  analytics_placement?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionArticles',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    items: null,
    spacing: null,
    analytics_placement: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: FeatureSectionArticlesItem[];
  spacing?: Spacing | null;
  analytics_placement?: string | null;
};



// Analytics
const sectionRef = ref<HTMLElement | null>(null);
const analyticItems = computed<AnalyticLinkItem[]>(() => {
  const result: AnalyticLinkItem[] = [];
  (props.items || []).forEach((card) => {
    (card.links || []).forEach((l) => {
      result.push({ destination_url: l.src ?? '', creative_name: l.creative_name ?? '' });
    });
    if (card.button?.src) {
      result.push({ destination_url: card.button.src, creative_name: card.button.creative_name ?? '' });
    }
  });
  return result;
});

const { trackSelectItem } = useSectionAnalytics(
  sectionRef,
  {
    placement: props.analytics_placement ?? '',
    items: analyticItems.value,
  },
  { mode: 'section', sectionName: 'FeatureSectionArticles' },
);

const onCardLinkClick = (payload: AnalyticLinkItem) => {
  trackSelectItem(payload);
};
const onCardButtonClick = (payload: AnalyticLinkItem) => {
  trackSelectItem(payload);
};

return { __sfc: true,props, sectionRef, analyticItems, trackSelectItem, onCardLinkClick, onCardButtonClick, AbSection, AbCardListItem, AbTitle, AbDescription, AbContainer, AbSectionLayout }
}

})